import React from "react";
import UrlFilterHelper from "./UrlFilterHelper";
import ArticleData from "./ArticleData";
import FileDownloadModal from "./FileDownloadModal";
import ArticleButtons from "./ArticleButtons";
import FootNoteData from "./FootNoteData";
import { Fancybox } from "@fancyapps/ui";

export default class ArticleModal extends React.Component {
    constructor(props) {
        super(props);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.closeDownloadModal = this.closeDownloadModal.bind(this);
        this.openDownloadModal = this.openDownloadModal.bind(this);
        this.getSeriesFromArticle = this.getSeriesFromArticle.bind(this);

        this.filterHelper = new UrlFilterHelper();

        this.state = {
            fileDownloadModalOpen: false,
            fileDownloadUrl: "",
            articleSeries: null,
        };
    }

    async componentDidMount() {
        document.addEventListener("keydown", this.handleKeyPress);

        if (!this.props.selectedSeries) {
            await this.getSeriesFromArticle();
        }

        // Initialize Fancybox
        Fancybox.bind("[data-fancybox]", {});
    }

    async componentDidUpdate(prevProps) {
        if (!this.props.selectedSeries && prevProps.selectedArticle.code !== this.props.selectedArticle.code) {
            await this.getSeriesFromArticle();
        }
        // Re-initialize Fancybox in case images changed
        Fancybox.bind("[data-fancybox]", {});
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
        document.removeEventListener("keydown", this.handleKeyPress);
        Fancybox.unbind("[data-fancybox]");
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    async setManualSeries(codes) {
        let targetSeries = "";

        // if we have multiple codes
        [].concat(codes).forEach((code) => {
            let match = this.props.series.filter((x) => x.code === code)[0];
            if (match) {
                targetSeries = match;
            }
        });

        this.setState({ articleSeries: targetSeries });
        return;
    }

    addToCart(code) {
        var cartApiUrl = i18n.baseUrl + "api/cart";
        fetch(cartApiUrl, {
            headers: {
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify({
                code: code,
                quantity: 1,
            }),
        });
    }

    handleClickOutside(event) {
        if (this.state.fileDownloadModalOpen) {
            return;
        }

        // Fix for avoiding article modal to close when Fancybox is open
        if (Fancybox.getInstance()) {
          return;
        }

        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.closeModal();
        }
    }

    handleKeyPress(event) {
        if (event.keyCode === 27) {
            this.closeModal();
        }
    }

    closeModal = () => {
        this.filterHelper.setQueryStringValue("am", "");
        this.setState({
            fileDownloadModalOpen: false,
        });

        this.props.onClose();
    };

    closeDownloadModal() {
        this.setState({
            fileDownloadModalOpen: false,
        });
    }

    openDownloadModal(url) {
        this.setState({
            fileDownloadModalOpen: true,
            fileDownloadUrl: url,
        });
    }

    async getSeriesFromArticle() {
        const response = await fetch(
            i18n.baseUrl + "api/seriesarticle/GetSeriesFromArticle?articleCode=" + this.props.selectedArticle?.code
        );

        if (response.ok) {
            const json = await response.json();
            await this.setManualSeries(json);
        }
        return;
    }

    convertToLinks(string) {
        var html = string.trim();
        if (html) {
            var url = /https?:\/\/[-|\w(\.|\/)]+/g;
            html = html.replace(
                url,
                '<a style="color:blue; text-decoration:underline;" target="_blank" title="Download" href="$&"><img src="/content/img/icons/pdf_large.png"></a>'
            );
        }

        return html;
    }

    render() {
        if (!this.props.showModal || this.props.selectedArticle === undefined) {
            return null;
        }

        let seriesToPass = this.props.selectedSeries;

        if (!seriesToPass || seriesToPass === "") {
            seriesToPass = this.state.articleSeries;
        }

        return (
            <>
                <div className="c-parts-modal-overlay" tabIndex="-1" onClick={this.handleClickOutside}></div>
                <div className="c-parts-modal" role="dialog">
                    <a onClick={this.closeModal} className="c-parts-modal__close" aria-label="Close modal">
                            <i className="icon-clear"></i>
                    </a>
                    <div ref={this.setWrapperRef} className="c-parts-modal__outer">
                        

                        <ArticleInfo
                            selectedArticle={this.props.selectedArticle}
                            filterGroups={this.props.filterGroups}
                            selectedSeries={seriesToPass}
                            openDownloadModal={this.openDownloadModal}
                            addToCart={this.addToCart}
                        />

                        <div className="c-parts-modal__block-area">
                            <RelatedParts
                                selectedArticle={this.props.selectedArticle}
                                filterGroups={this.props.filterGroups}
                            />
                            <SeriesInfo selectedSeries={seriesToPass} convertToLinks={this.convertToLinks} />

                            {this.props.footNoteData !== "" && <FootNoteData footNoteData={this.props.footNoteData} />}
                        </div>
                    </div>
                </div>
                <FileDownloadModal
                    open={this.state.fileDownloadModalOpen}
                    fileUrl={this.state.fileDownloadUrl}
                    fileDownloadSelectedArticleName={this.props.selectedArticle.name}
                    onClose={this.closeDownloadModal}
                />                
            </>
        );
    }
}

const RelatedParts = (props) => {
    if (props.selectedArticle.relatedItems === undefined || props.selectedArticle.relatedItems.length === 0) {
        return null;
    }
    return (
        <div className="c-related-parts-listing">
            <h3 className="c-related-parts-listing__heading">{i18n.getString("articlemodal.relatedparts")}</h3>
            <table className="c-related-parts-listing__table">
                <tbody>
                    <tr className="c-related-parts-listing__table-row">
                        <th className="c-related-parts-listing__table-header"></th>
                        <th className="c-related-parts-listing__table-header">
                            {i18n.getString("articlemodal.partno")}
                        </th>
                        <th className="c-related-parts-listing__table-header">
                            {i18n.getString("articlemodal.series")}
                        </th>
                    </tr>
                    {props.selectedArticle.relatedItems.map((related) => (
                        <tr className="c-related-parts-listing__table-row" key={related.name}>
                            <td className="c-related-parts-listing__table-item">
                                <img src={i18n.CdnHostName + related.imageUrl + "?width=300"} />
                            </td>
                            <td className="c-related-parts-listing__table-item">
                                <span className="c-related-parts-listing__label">
                                    {i18n.getString("articlemodal.partno")}
                                </span>
                                <a href={related.url} className="c-parts-listing__open-modal">
                                    {related.name}
                                </a>
                            </td>
                            <td className="c-related-parts-listing__table-item">
                                <span className="c-related-parts-listing__label">
                                    {i18n.getString("articlemodal.series")}
                                </span>
                                {related.seriesName}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

const ArticleInfo = (props) => {
    return (
        <>
            {props.selectedArticle && props.selectedSeries && (
                <div className="c-parts-modal__inner">
                    <div className="c-parts-modal__media">
                        <a
                            href={i18n.CdnHostName + props.selectedArticle.imageUrl}
                            className="d-block"
                            data-fancybox="article-gallery"
                        >
                            <img
                                src={i18n.CdnHostName + props.selectedArticle.imageUrl + "?height=300"}
                                className="c-parts-modal__image"
                                alt={props.selectedArticle.name}
                            />
                        </a>
                        {props.selectedArticle.articleillustrationImageUrl === "" ||
                            props.selectedArticle.articleillustrationImageUrl === props.selectedArticle.imageUrl ? null : (
                            <a
                                href={i18n.CdnHostName + props.selectedArticle.articleillustrationImageUrl}
                                data-fancybox="article-gallery"
                                className="d-block  mt-4"
                            >
                                <img
                                    src={
                                        i18n.CdnHostName +
                                        props.selectedArticle.articleillustrationImageUrl +
                                        "?height=300"
                                    }
                                    className="c-parts-modal__image"
                                    alt={props.selectedArticle.name}
                                />
                            </a>
                        )}
                    </div>
                    <div className="c-parts-modal__header">
                        <div className="c-parts-modal__data">
                            <div className="c-parts-modal__data-item">
                                <div className="c-parts-modal__label">{i18n.getString("articlemodal.partno")}</div>
                                <div className="c-parts-modal__value">{props.selectedArticle.name}</div>
                            </div>
                            <div className="c-parts-modal__data-item">
                                <div className="c-parts-modal__label">{i18n.getString("articlemodal.series")}</div>
                                <div className="c-parts-modal__value">{props.selectedSeries.name}</div>
                            </div>
                            {props.filterGroups.map((filterRow) =>
                                props.selectedArticle.dataCollection.map((field) => (
                                    <DataItem
                                        fieldValue={field.fieldValue}
                                        fieldName={field.fieldName}
                                        filterName={filterRow.text}
                                        key={field.fieldName}
                                    />
                                ))
                            )}

                            <div className="c-parts-modal__data-item">
                                <ArticleButtons
                                    disableColumn // make it a row instead of columns when modal
                                    onDownload={(data) => props.openDownloadModal(data)}
                                    models={props.selectedArticle.modelFiles}
                                    drawings={props.selectedArticle.drawingFiles}
                                    row={props.selectedArticle}
                                />
                            </div>
                        </div>

                        <div className="c-parts-modal__print">
                            <button
                                className="c-print-button"
                                onClick={() => window.printElement(".c-parts-modal__outer", "articleModal")}
                            >
                                <span className="c-print-button__icon">
                                    <i className="icon-local_printshop"></i>
                                </span>
                                {i18n.getString("articlemodal.print")}
                            </button>
                        </div>
                    </div>
                    <ArticleData selectedArticle={props.selectedArticle} />
                </div>
            )}
        </>
    );
};

const SeriesInfo = (props) => {
    return (
        <>
            {props.selectedSeries && (
                <div className="c-series-data">
                    <div className="row">
                        <div className="col-md-8">
                            <h3 className="c-series-data__heading">{props.selectedSeries.name}</h3>
                            <p>
                                {props.selectedSeries.tags?.map((tag) => (
                                    <span className="c-series-data__tag" key={tag}>
                                        {tag}
                                    </span>
                                ))}
                            </p>

                            <p
                                className="c-series-data__paragraph"
                                dangerouslySetInnerHTML={{ __html: props.convertToLinks(props.selectedSeries.excerpt) }}
                            />
                        </div>
                        <div className="col-md-4">
                            <a
                                href={i18n.CdnHostName + props.selectedSeries.imageUrl}
                                data-fancybox="article-gallery"
                            >
                                <img
                                    src={
                                        i18n.CdnHostName + props.selectedSeries.imageUrl + "?preset=c-series&width=250"
                                    }
                                    className="c-parts-modal__image"
                                    alt={props.selectedSeries.name}
                                />
                            </a>
                        </div>
                    </div>

                    {props.selectedSeries.flowchartImageUrl === null ||
                        props.selectedSeries.flowchartImageUrl?.length < 4 ? null : (
                        <div className="row justify-content-center mt-3">
                            <div className="col-md-9 mt-5">
                                <a
                                    href={i18n.CdnHostName + props.selectedSeries.flowchartImageUrl}
                                    data-fancybox="article-gallery"
                                >
                                    <img
                                        src={i18n.CdnHostName + props.selectedSeries.flowchartImageUrl + "?width=900"}
                                        className="c-parts-modal__image"
                                        alt={props.selectedSeries.name}
                                    />
                                </a>
                                <p className="mb-0 mt-4">
                                    <b>{props.selectedSeries.flowchart_Title}</b>
                                </p>
                                {props.selectedSeries.flowchart_X === null ? null : (
                                    <p className="m-0">
                                        <b>x: </b>
                                        {props.selectedSeries.flowchart_X}
                                        <br />
                                        <b>y: </b>
                                        {props.selectedSeries.flowchart_Y}
                                    </p>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

const DataItem = (props) => {
    if (props.filterName !== props.fieldName) {
        return null;
    }
    return (
        <div className="c-parts-modal__data-item">
            <div className="c-parts-modal__label">{props.fieldName}</div>
            <div className="c-parts-modal__value">{props.fieldValue}</div>
        </div>
    );
};
